import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileSize',
    pure: true,
    standalone: false
})
export class FileSizePipe implements PipeTransform {

  transform(value: number): string {

    const valueInBytes = value

    const valueInKyloBytes = Number((valueInBytes / 1024).toFixed(1))

    if (valueInKyloBytes < 1) return `${valueInBytes} Bytes`

    const valueInMegaBytes = Number((valueInKyloBytes / 1024).toFixed(1))

    if (valueInMegaBytes < 1) return `${valueInKyloBytes} KB`

    const valueInGigaBytes = Number((valueInMegaBytes / 1024).toFixed(1))

    if (valueInGigaBytes < 1) return `${valueInMegaBytes} MB`

    return `${valueInGigaBytes} GB`
  }

}
